import { NullValue, Node_Type, ButtonData_Type, HTMLData_Source } from 'ricos-schema';
import { isObject, has as has$1, merge, cloneDeep, isEmpty as isEmpty$1 } from 'lodash';

const updatePrivacyField = (target, isPrivate) => {
  const privacy = typeof isPrivate !== "undefined" ? isPrivate && "private" || "public" : void 0;
  target.privacy = privacy;
};

/**
 * Export.
 */

var toNoCase_1 = toNoCase;

/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/;
var hasSeparator = /(_|-|\.|:)/;
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/;

/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase(string) {
  if (hasSpace.test(string)) return string.toLowerCase()
  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
  return string.toLowerCase()
}

/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g;

/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate(string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : ''
  })
}

/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g;

/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize(string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
  })
}

var clean = toNoCase_1;

/**
 * Export.
 */

var toSpaceCase_1 = toSpaceCase;

/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */

function toSpaceCase(string) {
  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : ''
  }).trim()
}

var space = toSpaceCase_1;

/**
 * Export.
 */

var toCamelCase_1 = toCamelCase;

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase()
  })
}

// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.10.0
 */
/**
 * @since 2.0.0
 */
function identity(a) {
    return a;
}
function pipe(a, ab, bc, cd, de, ef, fg, gh, hi) {
    switch (arguments.length) {
        case 1:
            return a;
        case 2:
            return ab(a);
        case 3:
            return bc(ab(a));
        case 4:
            return cd(bc(ab(a)));
        case 5:
            return de(cd(bc(ab(a))));
        case 6:
            return ef(de(cd(bc(ab(a)))));
        case 7:
            return fg(ef(de(cd(bc(ab(a))))));
        case 8:
            return gh(fg(ef(de(cd(bc(ab(a)))))));
        case 9:
            return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
        default:
            var ret = arguments[0];
            for (var i = 1; i < arguments.length; i++) {
                ret = arguments[i](ret);
            }
            return ret;
    }
}

(undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
// -------------------------------------------------------------------------------------
// Either
// -------------------------------------------------------------------------------------
/** @internal */
var isLeft$1 = function (ma) { return ma._tag === 'Left'; };
/** @internal */
var left$1 = function (e) { return ({ _tag: 'Left', left: e }); };
/** @internal */
var right$1 = function (a) { return ({ _tag: 'Right', right: a }); };
// -------------------------------------------------------------------------------------
// Record
// -------------------------------------------------------------------------------------
/** @internal */
var has = Object.prototype.hasOwnProperty;

/**
 * The `FromEither` type class represents those data types which support errors.
 *
 * @since 2.10.0
 */
function fromPredicate$1(F) {
    return function (predicate, onFalse) { return function (a) {
        return F.fromEither(predicate(a) ? right$1(a) : left$1(onFalse(a)));
    }; };
}

/**
 * A `Magma` is a pair `(A, concat)` in which `A` is a non-empty set and `concat` is a binary operation on `A`
 *
 * See [Semigroup](https://gcanti.github.io/fp-ts/modules/Semigroup.ts.html) for some instances.
 *
 * @since 2.0.0
 */
// -------------------------------------------------------------------------------------
// combinators
// -------------------------------------------------------------------------------------
/**
 * The dual of a `Magma`, obtained by swapping the arguments of `concat`.
 *
 * @example
 * import { reverse, concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(reverse(N.MagmaSub))(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), 2)
 *
 * @category combinators
 * @since 2.11.0
 */
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * Given a sequence of `as`, concat them and return the total.
 *
 * If `as` is empty, return the provided `startWith` value.
 *
 * @example
 * import { concatAll } from 'fp-ts/Magma'
 * import * as N from 'fp-ts/number'
 *
 * const subAll = concatAll(N.MagmaSub)(0)
 *
 * assert.deepStrictEqual(subAll([1, 2, 3]), -6)
 *
 * @since 2.11.0
 */
var concatAll$2 = function (M) { return function (startWith) { return function (as) {
    return as.reduce(function (a, acc) { return M.concat(a, acc); }, startWith);
}; }; };

/**
 * If a type `A` can form a `Semigroup` it has an **associative** binary operation.
 *
 * ```ts
 * interface Semigroup<A> {
 *   readonly concat: (x: A, y: A) => A
 * }
 * ```
 *
 * Associativity means the following equality must hold for any choice of `x`, `y`, and `z`.
 *
 * ```ts
 * concat(x, concat(y, z)) = concat(concat(x, y), z)
 * ```
 *
 * A common example of a semigroup is the type `string` with the operation `+`.
 *
 * ```ts
 * import { Semigroup } from 'fp-ts/Semigroup'
 *
 * const semigroupString: Semigroup<string> = {
 *   concat: (x, y) => x + y
 * }
 *
 * const x = 'x'
 * const y = 'y'
 * const z = 'z'
 *
 * semigroupString.concat(x, y) // 'xy'
 *
 * semigroupString.concat(x, semigroupString.concat(y, z)) // 'xyz'
 *
 * semigroupString.concat(semigroupString.concat(x, y), z) // 'xyz'
 * ```
 *
 * *Adapted from https://typelevel.org/cats*
 *
 * @since 2.0.0
 */
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * Always return the first argument.
 *
 * @example
 * import * as S from 'fp-ts/Semigroup'
 *
 * assert.deepStrictEqual(S.first<number>().concat(1, 2), 1)
 *
 * @category instances
 * @since 2.10.0
 */
var first = function () { return ({ concat: identity }); };
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * Given a sequence of `as`, concat them and return the total.
 *
 * If `as` is empty, return the provided `startWith` value.
 *
 * @example
 * import { concatAll } from 'fp-ts/Semigroup'
 * import * as N from 'fp-ts/number'
 *
 * const sum = concatAll(N.SemigroupSum)(0)
 *
 * assert.deepStrictEqual(sum([1, 2, 3]), 6)
 * assert.deepStrictEqual(sum([]), 0)
 *
 * @since 2.10.0
 */
var concatAll$1 = concatAll$2;

(undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};

(undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};

(undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};

/**
 * `map` can be used to turn functions `(a: A) => B` into functions `(fa: Array<A>) => Array<B>`.
 * In practice it applies the base function to each element of the array and collects the
 * results in a new array.
 *
 * @example
 * import { map } from 'fp-ts/Array'
 * import { pipe } from 'fp-ts/function'
 *
 * const f = (n: number) => n * 2;
 * assert.deepStrictEqual(pipe([1, 2, 3], map(f)), [2, 4, 6]);
 *
 * @category Functor
 * @since 2.0.0
 */
var map$1 = function (f) { return function (fa) { return fa.map(function (a) { return f(a); }); }; };

// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * Given a sequence of `as`, concat them and return the total.
 *
 * If `as` is empty, return the monoid `empty` value.
 *
 * @example
 * import { concatAll } from 'fp-ts/Monoid'
 * import * as N from 'fp-ts/number'
 *
 * assert.deepStrictEqual(concatAll(N.MonoidSum)([1, 2, 3]), 6)
 * assert.deepStrictEqual(concatAll(N.MonoidSum)([]), 0)
 *
 * @since 2.10.0
 */
var concatAll = function (M) { return concatAll$1(M)(M.empty); };

/**
 * Test whether a `ReadonlyRecord` is empty.
 *
 * @example
 * import { isEmpty } from "fp-ts/ReadonlyRecord"
 *
 * assert.deepStrictEqual(isEmpty({}), true);
 * assert.deepStrictEqual(isEmpty({ a: 3 }), false);
 * @since 2.5.0
 */
var isEmpty = function (r) {
    for (var k in r) {
        if (has.call(r, k)) {
            return false;
        }
    }
    return true;
};
/**
 * @since 2.5.0
 */
var empty = {};
function getMonoid$1(S) {
    return {
        concat: function (first, second) {
            if (isEmpty(first)) {
                return second;
            }
            if (isEmpty(second)) {
                return first;
            }
            var r = Object.assign({}, first);
            for (var k in second) {
                if (has.call(second, k)) {
                    r[k] = has.call(first, k) ? S.concat(first[k], second[k]) : second[k];
                }
            }
            return r;
        },
        empty: empty
    };
}

var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Returns a `Monoid` instance for `Record`s, given a `Semigroup`
 * instance for the base type.
 * The `Monoid` makes the union of two `Record`s comining the
 * overlapping entries with the provided `Semigroup`.
 *
 * @example
 * import { SemigroupSum } from 'fp-ts/number'
 * import { getMonoid } from 'fp-ts/Record'
 *
 * const M = getMonoid(SemigroupSum);
 * assert.deepStrictEqual(M.concat({ foo: 123, bar: 234 }, { foo: 456, baz: 567 }), { foo: 579 , bar: 234, baz: 567 });
 *
 * @category instances
 * @since 2.0.0
 */
var getMonoid = getMonoid$1;

// -------------------------------------------------------------------------------------
// model
// -------------------------------------------------------------------------------------
/**
 * @category destructors
 * @since 2.5.0
 */
function fst$1(ea) {
    return ea[0];
}
/**
 * @category destructors
 * @since 2.5.0
 */
function snd$1(ea) {
    return ea[1];
}

// -------------------------------------------------------------------------------------
// model
// -------------------------------------------------------------------------------------
/**
 * @category destructors
 * @since 2.0.0
 */
var fst = fst$1;
/**
 * @category destructors
 * @since 2.0.0
 */
var snd = snd$1;
// -------------------------------------------------------------------------------------
// type class members
// -------------------------------------------------------------------------------------
/**
 * Map a pair of functions over the two type arguments of the bifunctor.
 *
 * @category Bifunctor
 * @since 2.0.0
 */
var bimap = function (f, g) { return function (fa) { return [g(fst(fa)), f(snd(fa))]; }; };

// -------------------------------------------------------------------------------------
// constructors
// -------------------------------------------------------------------------------------
/**
 * Constructs a new `Either` holding a `Left` value. This usually represents a failure, due to the right-bias of this
 * structure.
 *
 * @category constructors
 * @since 2.0.0
 */
var left = left$1;
/**
 * Constructs a new `Either` holding a `Right` value. This usually represents a successful value due to the right bias
 * of this structure.
 *
 * @category constructors
 * @since 2.0.0
 */
var right = right$1;
// -------------------------------------------------------------------------------------
// instances
// -------------------------------------------------------------------------------------
/**
 * @category instances
 * @since 2.0.0
 */
var URI = 'Either';
/**
 * Semigroup returning the left-most non-`Left` value. If both operands are `Right`s then the inner values are
 * concatenated using the provided `Semigroup`
 *
 * @example
 * import { getSemigroup, left, right } from 'fp-ts/Either'
 * import { SemigroupSum } from 'fp-ts/number'
 *
 * const S = getSemigroup<string, number>(SemigroupSum)
 * assert.deepStrictEqual(S.concat(left('a'), left('b')), left('a'))
 * assert.deepStrictEqual(S.concat(left('a'), right(2)), right(2))
 * assert.deepStrictEqual(S.concat(right(1), left('b')), right(1))
 * assert.deepStrictEqual(S.concat(right(1), right(2)), right(3))
 *
 * @category instances
 * @since 2.0.0
 */
var getSemigroup = function (S) { return ({
    concat: function (x, y) { return (isLeft(y) ? x : isLeft(x) ? y : right(S.concat(x.right, y.right))); }
}); };
/**
 * @category instance operations
 * @since 2.0.0
 */
var map = function (f) { return function (fa) {
    return isLeft(fa) ? fa : right(f(fa.right));
}; };
/**
 * @category instances
 * @since 2.10.0
 */
var FromEither = {
    URI: URI,
    fromEither: identity
};
/**
 * @example
 * import { fromPredicate, left, right } from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     1,
 *     fromPredicate(
 *       (n) => n > 0,
 *       () => 'error'
 *     )
 *   ),
 *   right(1)
 * )
 * assert.deepStrictEqual(
 *   pipe(
 *     -1,
 *     fromPredicate(
 *       (n) => n > 0,
 *       () => 'error'
 *     )
 *   ),
 *   left('error')
 * )
 *
 * @category constructors
 * @since 2.0.0
 */
var fromPredicate = 
/*#__PURE__*/
fromPredicate$1(FromEither);
// -------------------------------------------------------------------------------------
// refinements
// -------------------------------------------------------------------------------------
/**
 * Returns `true` if the either is an instance of `Left`, `false` otherwise.
 *
 * @category refinements
 * @since 2.0.0
 */
var isLeft = isLeft$1;
// -------------------------------------------------------------------------------------
// destructors
// -------------------------------------------------------------------------------------
/**
 * Less strict version of [`match`](#match).
 *
 * @category destructors
 * @since 2.10.0
 */
var matchW = function (onLeft, onRight) { return function (ma) {
    return isLeft(ma) ? onLeft(ma.left) : onRight(ma.right);
}; };
/**
 * Takes two functions and an `Either` value, if the value is a `Left` the inner value is applied to the first function,
 * if the value is a `Right` the inner value is applied to the second function.
 *
 * @example
 * import { match, left, right } from 'fp-ts/Either'
 * import { pipe } from 'fp-ts/function'
 *
 * function onLeft(errors: Array<string>): string {
 *   return `Errors: ${errors.join(', ')}`
 * }
 *
 * function onRight(value: number): string {
 *   return `Ok: ${value}`
 * }
 *
 * assert.strictEqual(
 *   pipe(
 *     right(1),
 *     match(onLeft, onRight)
 *   ),
 *   'Ok: 1'
 * )
 * assert.strictEqual(
 *   pipe(
 *     left(['error 1', 'error 2']),
 *     match(onLeft, onRight)
 *   ),
 *   'Errors: error 1, error 2'
 * )
 *
 * @category destructors
 * @since 2.10.0
 */
var match = matchW;
/**
 * Alias of [`match`](#match).
 *
 * @category destructors
 * @since 2.0.0
 */
var fold = match;

const firstRight = (candidate, defaultT, resolvers) => {
  const firstRightSemi = getSemigroup(first());
  const concatFirstRightSemi = concatAll$1(firstRightSemi)(left(defaultT));
  return pipe(
    concatFirstRightSemi(
      pipe(
        resolvers,
        map$1(
          (r) => pipe(
            candidate,
            fromPredicate(r[0], () => defaultT),
            map(r[1])
          )
        )
      )
    ),
    fold(identity, identity)
  );
};

const isBoolValue = (val) => typeof val.boolValue === "boolean";
const isStringValue = (val) => typeof val.stringValue === "string";
const isNumberValue = (val) => typeof val.numberValue === "number";
const isArrayValue = (val) => {
  var _a;
  return isObject(val.listValue) && Array.isArray((_a = val.listValue) == null ? void 0 : _a.values);
};
const isStructValue = (val) => {
  var _a;
  return isObject(val.structValue) && isObject((_a = val.structValue) == null ? void 0 : _a.fields);
};
const isNullValue = (val) => val.nullValue === NullValue.NULL_VALUE;

const mergeJsonMap = getMonoid(first());
const toRecord = ([k, v]) => ({ [k]: v });
const convertStructToJson = (message) => pipe(
  message.fields,
  Object.entries,
  map$1(bimap(convertValueToJson, identity)),
  map$1(toRecord),
  concatAll(mergeJsonMap)
);
const convertValueToJson = (message) => firstRight(message, null, [
  [isBoolValue, ({ boolValue }) => boolValue],
  [isNumberValue, ({ numberValue }) => numberValue],
  [isStringValue, ({ stringValue }) => stringValue],
  [isNullValue, () => null],
  [isArrayValue, (m) => convertListToJson(m.listValue || { values: [] })],
  [isStructValue, (m) => convertStructToJson(m.structValue || { fields: {} })]
]);
const convertListToJson = (message) => pipe(message.values, map$1(convertValueToJson));

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const WRAP = "wrap";
const NO_WRAP = "nowrap";
const parseLink = ({
  url,
  rel,
  target,
  anchor,
  customData
}) => ({
  anchor,
  url,
  rel: rel && Object.entries(rel).flatMap(([key, value]) => value ? key : []).join(" "),
  target: target && "_" + target.toLowerCase(),
  customData
});
const convertContainerData = (data, nodeType) => {
  const { width, alignment, spoiler, height, textWrap = true } = data.containerData || {};
  const { enabled = false, description, buttonText } = spoiler || {};
  data.config = Object.assign(
    {},
    data.config,
    (width == null ? void 0 : width.size) && { size: toCamelCase_1(width.size) },
    (width == null ? void 0 : width.custom) && { width: parseInt(width.custom) },
    (height == null ? void 0 : height.custom) && { height: parseInt(height.custom) },
    alignment && { alignment: alignment == null ? void 0 : alignment.toLowerCase() },
    spoiler && {
      spoiler: {
        enabled,
        description,
        buttonContent: buttonText
      }
    },
    { textWrap: textWrap ? WRAP : NO_WRAP }
  );
  if ((nodeType === Node_Type.IMAGE || nodeType === Node_Type.BUTTON) && (width == null ? void 0 : width.custom)) {
    data.config.size = "inline";
  } else if (nodeType === Node_Type.BUTTON) {
    data.config.size = "small";
    data.config.width = "fit-content";
  } else if ([Node_Type.MAP, Node_Type.HTML].includes(nodeType) && (width == null ? void 0 : width.custom)) {
    data.config.size = "content";
  }
  delete data.containerData;
};
const convertVideoData = (data) => {
  var _a, _b;
  const videoSrc = (_a = data.video) == null ? void 0 : _a.src;
  const { src, width, height } = data.thumbnail || {};
  if (videoSrc == null ? void 0 : videoSrc.url) {
    data.src = videoSrc.url;
    data.metadata = { thumbnail_url: src == null ? void 0 : src.url, width, height, title: data.title };
  } else if ((videoSrc == null ? void 0 : videoSrc.id) || (videoSrc == null ? void 0 : videoSrc.custom)) {
    const pathname = (src == null ? void 0 : src.id) || (src == null ? void 0 : src.custom);
    data.src = {
      pathname: (videoSrc == null ? void 0 : videoSrc.id) || (videoSrc == null ? void 0 : videoSrc.custom),
      thumbnail: pathname ? { pathname, width, height } : void 0
    };
  }
  data.duration = (_b = data.video) == null ? void 0 : _b.duration;
  delete data.video;
  delete data.title;
  delete data.thumbnail;
};
const convertAudioData = (data) => {
  var _a, _b, _c, _d;
  const { coverImage } = data;
  if (coverImage) {
    const { width, height } = coverImage;
    const id = (_b = coverImage == null ? void 0 : coverImage.id) != null ? _b : (_a = coverImage == null ? void 0 : coverImage.src) == null ? void 0 : _a.id;
    const file_name = (_d = coverImage == null ? void 0 : coverImage.file_name) != null ? _d : (_c = coverImage == null ? void 0 : coverImage.src) == null ? void 0 : _c.id;
    data.coverImage = {
      id,
      file_name,
      width,
      height
    };
  }
};
const convertExternalData = (data) => {
  const draftData = convertStructToJson(data);
  Object.entries(draftData).forEach(([k, v]) => {
    data[k] = v;
  });
  delete data.fields;
};
const convertDividerData = (data) => {
  var _a, _b, _c;
  data.type = (_a = data.lineStyle) == null ? void 0 : _a.toLowerCase();
  delete data.lineStyle;
  data.config = data.config || {};
  if (has$1(data, "width")) {
    data.config.size = (_b = data.width) == null ? void 0 : _b.toLowerCase();
    delete data.width;
  }
  if (has$1(data, "alignment")) {
    data.config.alignment = (_c = data.alignment) == null ? void 0 : _c.toLowerCase();
    delete data.alignment;
  }
  delete data.containerData;
};
var GalleryLayout = /* @__PURE__ */ ((GalleryLayout2) => {
  GalleryLayout2[GalleryLayout2["COLLAGE"] = 0] = "COLLAGE";
  GalleryLayout2[GalleryLayout2["MASONRY"] = 1] = "MASONRY";
  GalleryLayout2[GalleryLayout2["GRID"] = 2] = "GRID";
  GalleryLayout2[GalleryLayout2["THUMBNAIL"] = 3] = "THUMBNAIL";
  GalleryLayout2[GalleryLayout2["SLIDER"] = 4] = "SLIDER";
  GalleryLayout2[GalleryLayout2["SLIDESHOW"] = 5] = "SLIDESHOW";
  GalleryLayout2[GalleryLayout2["PANORAMA"] = 6] = "PANORAMA";
  GalleryLayout2[GalleryLayout2["COLUMN"] = 7] = "COLUMN";
  GalleryLayout2[GalleryLayout2["MAGIC"] = 8] = "MAGIC";
  GalleryLayout2[GalleryLayout2["FULLSIZE"] = 9] = "FULLSIZE";
  return GalleryLayout2;
})(GalleryLayout || {});
const convertGalleryStyles = (options) => {
  const styles = {};
  has$1(options, "layout.type") && (styles.galleryLayout = parseInt(GalleryLayout[options.layout.type]));
  has$1(options, "layout.horizontalScroll") && (styles.oneRow = options.layout.horizontalScroll);
  has$1(options, "layout.orientation") && (styles.isVertical = options.layout.orientation === "COLUMNS");
  has$1(options, "layout.numberOfColumns") && (styles.numberOfImagesPerRow = options.layout.numberOfColumns);
  has$1(options, "layout.mobileNumberOfColumns") && (styles.m_numberOfImagesPerRow = options.layout.mobileNumberOfColumns);
  has$1(options, "item.targetSize") && (styles.gallerySizePx = options.item.targetSize);
  has$1(options, "item.ratio") && (styles.cubeRatio = options.item.ratio);
  has$1(options, "item.crop") && (styles.cubeType = options.item.crop.toLowerCase());
  has$1(options, "item.spacing") && (styles.imageMargin = options.item.spacing);
  has$1(options, "thumbnails.placement") && (styles.galleryThumbnailsAlignment = options.thumbnails.placement.toLowerCase());
  has$1(options, "thumbnails.spacing") && (styles.thumbnailSpacings = Math.trunc(options.thumbnails.spacing));
  return styles;
};
const convertGalleryItem = (item) => {
  var _a, _b;
  const type = has$1(item, "image") && !isEmpty$1(item.image) ? "image" : "video";
  const {
    src: { url },
    height,
    width
  } = ((_a = item[type]) == null ? void 0 : _a.media) || { src: {} };
  item.url = url;
  item.metadata = { height, width, type };
  has$1(item, "title") && (item.metadata.title = item.title);
  has$1(item, "altText") && (item.metadata.altText = item.altText);
  if (has$1(item, "video.thumbnail")) {
    const {
      src: { url: url2 },
      height: height2,
      width: width2
    } = item.video.thumbnail;
    item.metadata.poster = { url: url2, height: height2, width: width2 };
  }
  ((_b = item.image) == null ? void 0 : _b.link) && (item.metadata.link = parseLink(item.image.link));
  delete item.video;
  delete item.image;
  delete item.title;
  delete item.altText;
  return item;
};
const convertGalleryData = (data) => {
  has$1(data, "items") && (data.items = data.items.map((item) => convertGalleryItem(item)));
  has$1(data, "options") && (data.styles = convertGalleryStyles(data.options));
  delete data.options;
};
const convertImageData = (data) => {
  var _a, _b;
  const { link, config, image, altText, caption } = data;
  const { src, width, height } = image || {};
  const id = (src == null ? void 0 : src.id) || (src == null ? void 0 : src.custom);
  data.src = id ? { id, file_name: id, width, height } : { url: src == null ? void 0 : src.url, source: "static", width, height };
  const links = __spreadValues(__spreadValues({}, (link == null ? void 0 : link.anchor) ? { anchor: link == null ? void 0 : link.anchor } : {}), link ? { link: parseLink(link) } : {});
  if ((_a = links.link) == null ? void 0 : _a.customData) {
    const parsedCustomData = parseLinkCustomData((_b = links.link) == null ? void 0 : _b.customData);
    merge(links.link, parsedCustomData);
    if (!parsedCustomData.customData) {
      delete links.link.customData;
    }
  }
  data.config = __spreadValues(__spreadValues({}, config || {}), links);
  data.metadata = typeof altText === "string" || typeof caption === "string" ? {
    caption,
    alt: altText
  } : void 0;
  delete data.image;
  delete data.link;
  delete data.caption;
  delete data.altText;
};
const convertGIFData = (data) => {
  const { original = {}, downsized = {}, height, width } = data;
  data.gif = {
    originalUrl: original.gif,
    originalMp4: original.mp4,
    stillUrl: original.still,
    downsizedUrl: downsized.gif,
    downsizedSmallMp4: downsized.mp4,
    downsizedStillUrl: downsized.still,
    height,
    width
  };
  delete data.original;
  delete data.downsized;
  delete data.height;
  delete data.width;
};
const convertPollData = (data) => {
  var _a;
  has$1(data, "layout.poll.type") && (data.layout.poll.type = data.layout.poll.type.toLowerCase());
  has$1(data, "layout.poll.direction") && (data.layout.poll.direction = data.layout.poll.direction.toLowerCase());
  if (has$1(data, "layout.options")) {
    data.layout.option = data.layout.options;
    delete data.layout.options;
  }
  if (has$1(data, "design")) {
    const { poll = {}, options = {} } = data.design;
    const { background, borderRadius } = poll;
    const getBackground = (background2) => {
      var _a2, _b, _c, _d, _e, _f, _g;
      return (background2 == null ? void 0 : background2.gradient) ? {
        angle: (_a2 = background2 == null ? void 0 : background2.gradient) == null ? void 0 : _a2.angle,
        start: (_b = background2 == null ? void 0 : background2.gradient) == null ? void 0 : _b.startColor,
        end: (_c = background2 == null ? void 0 : background2.gradient) == null ? void 0 : _c.lastColor
      } : ((_e = (_d = background2 == null ? void 0 : background2.color) == null ? void 0 : _d.charAt) == null ? void 0 : _e.call(_d, 0)) === "#" ? background2 == null ? void 0 : background2.color : (_g = (_f = background2 == null ? void 0 : background2.image) == null ? void 0 : _f.src) == null ? void 0 : _g.url;
    };
    data.design = {
      poll: {
        backgroundType: (_a = background == null ? void 0 : background.type) == null ? void 0 : _a.toLowerCase(),
        background: getBackground(background),
        borderRadius: `${borderRadius}px`
      },
      option: { borderRadius: `${options.borderRadius}px` }
    };
  }
  has$1(data, "poll.pollId") && (data.poll.id = data.poll.pollId);
  delete data.poll.pollId;
  has$1(data, "poll.creatorId") && (data.poll.createdBy = data.poll.creatorId);
  delete data.poll.creatorId;
  has$1(data, "poll.image.src.url") && (data.poll.mediaId = data.poll.image.src.url);
  delete data.poll.image;
  has$1(data, "poll.options") && (data.poll.options = data.poll.options.map((_b) => {
    var _c = _b, { image } = _c, rest = __objRest(_c, ["image"]);
    var _a2;
    return __spreadValues({
      mediaId: (_a2 = image == null ? void 0 : image.src) == null ? void 0 : _a2.url
    }, rest);
  }));
  if (has$1(data, "poll.settings")) {
    const { showVotesCount, showVoters, permissions } = data.poll.settings;
    const { view, vote, allowMultipleVotes } = permissions || {};
    const getResultsVisibility = (view2) => view2 === "EVERYONE" ? "ALWAYS" : view2 === "VOTERS" ? "VOTERS_ONLY" : "ONLY_ME";
    data.poll.settings = {
      resultsVisibility: getResultsVisibility(view),
      multipleVotes: allowMultipleVotes,
      voteRole: vote,
      votersDisplay: showVoters,
      votesDisplay: showVotesCount
    };
  }
  data.config.size = "large";
  data.config.width = "full-width";
};
const convertAppEmbedData = (data) => {
  const { type, itemId, name, image, url, bookingData, eventData, imageSrc } = data;
  const { src, width, height } = image || {};
  data.type = type.toLowerCase();
  const selectedProduct = __spreadValues(__spreadValues({
    id: itemId,
    name,
    imageSrc: (src == null ? void 0 : src.url) || imageSrc,
    pageUrl: url
  }, bookingData || {}), eventData || {});
  width && (selectedProduct.imageWidth = width);
  height && (selectedProduct.imageHeight = height);
  data.selectedProduct = selectedProduct;
  delete data.id;
  delete data.itemId;
  delete data.name;
  delete data.imageSrc;
  delete data.image;
  delete data.url;
  bookingData && delete data.bookingData;
  eventData && delete data.eventData;
};
const convertLinkPreviewData = (data) => {
  if (data.thumbnailUrl) {
    data.thumbnail_url = data.thumbnailUrl;
    delete data.thumbnailUrl;
  }
  if (data.link) {
    data.config.link = parseLink(data.link);
    delete data.link;
  }
};
const convertFileData = (data) => {
  const { url, id, custom, private: isPrivate } = data.src || {};
  data.url = url;
  data.id = id || custom;
  updatePrivacyField(data, isPrivate);
  delete data.src;
};
const convertButtonData = (data) => {
  const { link, text, type, styles } = data;
  const { colors, border } = styles || {};
  const { width, radius } = border || {};
  const convertedLink = type === ButtonData_Type.LINK && link ? parseLink(link) : {};
  data.button = {
    settings: __spreadValues({
      buttonText: text
    }, convertedLink),
    design: {
      borderRadius: radius,
      borderWidth: width,
      background: colors == null ? void 0 : colors.background,
      color: colors == null ? void 0 : colors.text,
      borderColor: colors == null ? void 0 : colors.border
    }
  };
  delete data.link;
  delete data.text;
  delete data.type;
  delete data.styles;
};
const convertHTMLData = (data) => {
  var _a;
  const { html, url, source } = data;
  const srcType = typeof html === "string" ? "html" : "url";
  data.srcType = srcType;
  data.src = (_a = html || url) != null ? _a : "";
  source === HTMLData_Source.ADSENSE && (data.config.isAdsense = true);
  delete data.source;
  delete data[srcType];
};
const convertMapData = (data) => {
  const {
    draggable,
    marker,
    streetViewControl,
    zoomControl,
    locationName,
    viewModeControl,
    initialZoom,
    mapType
  } = data.mapSettings;
  data.mapSettings.isDraggingAllowed = draggable;
  data.mapSettings.isMarkerShown = marker;
  data.mapSettings.isStreetViewControlShown = streetViewControl;
  data.mapSettings.isZoomControlShown = zoomControl;
  data.mapSettings.locationDisplayName = locationName;
  data.mapSettings.zoom = initialZoom;
  data.mapSettings.mode = mapType == null ? void 0 : mapType.toLowerCase();
  delete data.mapSettings.draggable;
  delete data.mapSettings.marker;
  delete data.mapSettings.streetViewControl;
  delete data.mapSettings.zoomControl;
  delete data.mapSettings.locationName;
  delete data.mapSettings.initialZoom;
  delete data.mapSettings.mapType;
  if (viewModeControl) {
    data.mapSettings.isViewControlShown = viewModeControl;
    delete data.mapSettings.viewModeControl;
  }
};
const convertEmbedData = (data) => {
  data.config = __spreadProps(__spreadValues({}, (data == null ? void 0 : data.config) || {}), {
    alignment: "center",
    size: "content",
    link: { url: data.src, target: "_blank", rel: "noopener" }
  });
  const { html, thumbnailUrl, title, description } = data.oembed;
  data.html = html;
  thumbnailUrl && (data.thumbnail_url = thumbnailUrl);
  typeof title === "string" && (data.title = title);
  description && (data.description = description);
  delete data.oembed;
  delete data.src;
};
const parseLinkCustomData = (customData) => {
  try {
    return { customData: JSON.parse(customData) };
  } catch (e) {
    console.error("failed to parse customData", customData);
    return { customData };
  }
};
const converters = {
  [Node_Type.VIDEO]: convertVideoData,
  [Node_Type.AUDIO]: convertAudioData,
  [Node_Type.DIVIDER]: convertDividerData,
  [Node_Type.FILE]: convertFileData,
  [Node_Type.GIF]: convertGIFData,
  [Node_Type.IMAGE]: convertImageData,
  [Node_Type.POLL]: convertPollData,
  [Node_Type.APP_EMBED]: convertAppEmbedData,
  [Node_Type.LINK_PREVIEW]: convertLinkPreviewData,
  [Node_Type.BUTTON]: convertButtonData,
  [Node_Type.HTML]: convertHTMLData,
  [Node_Type.MAP]: convertMapData,
  [Node_Type.EMBED]: convertEmbedData,
  [Node_Type.GALLERY]: convertGalleryData,
  [Node_Type.EXTERNAL]: convertExternalData
};
const convertNodeDataToDraftNoInnerRCE = (nodeType, data) => {
  if (!data) {
    return {};
  }
  const newData = cloneDeep(data);
  if (newData.containerData) {
    convertContainerData(newData, nodeType);
  }
  if (nodeType in converters) {
    const convert = converters[nodeType];
    convert(newData);
  }
  return JSON.parse(JSON.stringify(newData));
};

export { convertNodeDataToDraftNoInnerRCE as convertNodeDataToDraft };
